import styled from 'styled-components'
import PropTypes from 'prop-types'
import { colors } from '@lmc/common/constants'
import { FormInput } from '../LEGACY/elemental'
import { Icon } from '@lmc/ui-kit'

const Wrapper = styled.div`
    position: relative;
`

const IconButton = styled.button`
    background: none;
    border: none;
    color: ${colors.darkgrey};
    height: 100%;
    position: absolute;
    right: 0;
    text-align: center;
    top: 0;
    width: 2.2em;
    z-index: 2;

    ${({ hasValue }) =>
            hasValue &&
            `
    &:hover,
    &:focus {
      color: ${colors.red};
      outline: 0;
      text-decoration: none;
    }
    &:active {
      color: ${colors.red};
    }
    transition: color 0.2s ease;
  `}
`

function ListHeaderSearch({
                              focusInput,
                              handleChange,
                              handleClear,
                              handleKeyup,
                              inputStyle,
                              placeholder,
                              multiline,
                              value,
                              testId,
                              ...props
                          }) {
    return (
        <Wrapper {...props}>
            <FormInput
                data-search-input-field
                onChange={handleChange}
                onKeyUp={handleKeyup}
                placeholder={placeholder || 'Search'}
                style={inputStyle}
                value={value}
                multiline={multiline}
                data-testid={testId ? `${testId}-input` : 'search-input'}
            />
            <IconButton
                hasValue={!!value.length}
                data-search-input-field-clear-icon
                disabled={!value.length}
                onClick={value.length ? handleClear : null}
                title="Clear search query"
                type="button"
                data-testid={
                    testId
                        ? `${testId}-${value.length ? 'clear' : 'search'}-btn`
                        : `${value.length ? 'clear' : 'search'}-btn`
                }
            >
                <Icon name={value.length ? 'CloseOutlined' : 'SearchOutlined'}></Icon>
            </IconButton>
        </Wrapper>
    )
}

ListHeaderSearch.propTypes = {
    focusInput: PropTypes.bool,
    handleChange: PropTypes.func.isRequired,
    handleClear: PropTypes.func.isRequired,
    handleKeyup: PropTypes.func,
    value: PropTypes.string
}

export default ListHeaderSearch
